import { render, staticRenderFns } from "./Notices.vue?vue&type=template&id=1b0f00b8&scoped=true"
import script from "./Notices.vue?vue&type=script&lang=js"
export * from "./Notices.vue?vue&type=script&lang=js"
import style0 from "./Notices.vue?vue&type=style&index=0&id=1b0f00b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0f00b8",
  null
  
)

export default component.exports